import { render } from "./ModalRemoveVoucher.vue?vue&type=template&id=4a9ddc5d"
import script from "./ModalRemoveVoucher.vue?vue&type=script&lang=js"
export * from "./ModalRemoveVoucher.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__